"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manageFieldErrors = exports.createValidateOnChange = exports.createValidator = void 0;
const utils_1 = require("../utils");
function createValidator(validator) {
    return (value) => {
        if (!validator)
            return true;
        // allowed empty values
        if (value === '' || value === null)
            return true;
        if (typeof validator === 'function') {
            return validator(value);
        }
        return true;
    };
}
exports.createValidator = createValidator;
function createValidateOnChange(eventProcessor, validate, fieldState, setFieldState, consumerOnChange, errors, configs) {
    return (shouldUpdateIsTouched = false) => (event) => {
        const valueFromEvent = eventProcessor(event);
        const updatedIsEmpty = (0, utils_1.isFieldEmpty)(valueFromEvent);
        const nextState = Object.assign(Object.assign({}, fieldState), { value: valueFromEvent, isDirty: true, isEmpty: updatedIsEmpty });
        if (shouldUpdateIsTouched)
            nextState.isTouched = true;
        const isValid = validate(valueFromEvent);
        nextState.isValid = isValid;
        if (isValid) {
            nextState.lastValidValue = valueFromEvent;
        }
        setFieldState(nextState);
        consumerOnChange(event, {
            // consumer will receive last valid value
            value: nextState.lastValidValue,
            errors: manageFieldErrors(errors, nextState, Object.assign(Object.assign({}, configs), { 
                // pass all errors to consumer
                hideErrorsUntilBlur: false }))
        });
    };
}
exports.createValidateOnChange = createValidateOnChange;
function manageFieldErrors(existingErrors, { isValid, isEmpty, isTouched }, { invalidMsg, isRequired, isRequiredMsg, hideErrorsUntilBlur = true }) {
    const errorSet = new Set(existingErrors);
    // remove stale errors
    if (isValid && invalidMsg) {
        errorSet.delete(invalidMsg);
    }
    if (isValid && isRequiredMsg && isRequired && !isEmpty) {
        errorSet.delete(isRequiredMsg);
    }
    if (hideErrorsUntilBlur && !isTouched) {
        // don't append new errors
        return Array.from(errorSet);
    }
    // append new errors
    if (!isValid && invalidMsg) {
        errorSet.add(invalidMsg);
    }
    if (isEmpty && isRequired && isRequiredMsg) {
        errorSet.add(isRequiredMsg);
    }
    return Array.from(errorSet);
}
exports.manageFieldErrors = manageFieldErrors;
//# sourceMappingURL=utils.js.map